import { Box, Button, Typography } from '@mui/material';

import FooterPage from './footerPage';
import Four_Icon from 'src/resources/images/NumberOne.png';
import NavBar from 'src/components/heroSection/navBar';
import React from 'react';
import Zero_Icon from 'src/resources/images/NumberZero.png';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Box display="flex" flexDirection="column" minHeight="100vh" minWidth="100%">
            <NavBar />
            <Box
                alignItems="center"
                display="flex"
                flexDirection="column"
                flexGrow={1}
                gap={3}
                justifyContent="center"
                marginTop={{
                    md: 'calc(12vh + 85px)', // Large screens
                    xs: 'calc(10vh + 80px)', // Extra small screens
                }}
                paddingBottom={{
                    md: 'calc(12vh + 120px)',
                    xs: 'calc(10vh + 35px)',
                }}
            >
                <Box alignItems="center" display="flex" gap={{ sm: 1.5, xs: 0.5 }} justifyContent="center" width="100%">
                    <Box
                        alt="4"
                        component="img"
                        src={Four_Icon}
                        sx={{ height: { sm: 140, xs: 100 }, width: { sm: 140, xs: 100 } }}
                    />
                    <Box
                        alt="0"
                        component="img"
                        src={Zero_Icon}
                        sx={{ height: { sm: 140, xs: 100 }, width: { sm: 140, xs: 100 } }}
                    />
                    <Box
                        alt="4"
                        component="img"
                        src={Four_Icon}
                        sx={{ height: { sm: 140, xs: 100 }, width: { sm: 140, xs: 100 } }}
                    />
                </Box>
                <Typography mt={1} textAlign="center" variant="h3">
                    Oops! Page Not Found
                </Typography>
                <Button
                    onClick={() => navigate('/')}
                    sx={{
                        '&::before': {
                            background: 'linear-gradient(to right, #19BCFE, #EBD529)', // Keep the gradient
                            borderRadius: '8px', // Ensures border follows the curve
                            content: '""',
                            inset: 0,
                            mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                            maskComposite: 'exclude',
                            padding: '2px', // Matches border thickness
                            position: 'absolute',
                        },

                        backgroundColor: 'transparent',
                        color: 'rgba(255, 255, 255, 0.75)',
                        fontSize: { sm: '20px', xs: '18px' },
                        fontWeight: 'bold',
                        overflow: 'hidden',
                        padding: { sm: '14px 22px', xs: '10px 16px' },
                        transition: '0.3s',
                    }}
                    variant="outlined"
                >
                    Back to Home
                </Button>
            </Box>
            <FooterPage />
        </Box>
    );
};

export default NotFound;
